export const TABS = [
	'Wine',
	'Locker',
	'5x5',
	'5x10',
	'5x15',
	'10x10',
	'10x15',
	'10x20',
	'10x25',
	'10x30',
	'10x35',
	'10x40',
	'10x50',
];

export const CONTENT = {
	Wine: {
		title: 'Wine Storage',
		sqft: 'Varies',
		looksLike: 'Climate controlled locker designed for wine bottle storage',
		whatWillFit: 'Size varies, often starting around 6 cases',
	},

	Locker: {
		title: 'Storage Lockers',
		sqft: '25 sq ft or less',
		looksLike: 'Small coat closet or half bathroom',
		whatWillFit: 'Clothes, tools, seasonal items, documents',
	},

	'5x5': {
		title: '5x5 Storage',
		sqft: '25 Square Feet',
		looksLike: 'Small closet or half bathroom',
		whatWillFit: 'Holiday decorations, off-season clothing, small boxes',
	},

	'5x10': {
		title: '5x10 Storage',
		sqft: '50 Square Feet',
		looksLike: 'Large walk-in closet',
		whatWillFit: 'Studio bedroom set, bicycle, storage boxes',
	},

	'5x15': {
		title: '5x15 Storage',
		sqft: '75 Square Feet',
		looksLike: 'Small bedroom',
		whatWillFit: 'Queen mattress, love seat, television, boxes',
	},

	'10x10': {
		title: '10x10 Storage',
		sqft: '100 Square Feet',
		looksLike: 'Bedroom',
		whatWillFit: 'Full bedroom set, compact furniture, boxes',
	},

	'10x15': {
		title: '10x15 Storage',
		sqft: '150 Square Feet',
		looksLike: 'Large bedroom',
		whatWillFit: 'Contents of a small house or apartment, appliances',
	},

	'10x20': {
		title: '10x20 Storage',
		sqft: '200 Square Feet',
		looksLike: 'One-car garage',
		whatWillFit: 'Household items, dining room set, workout equipment',
	},

	'10x25': {
		title: '10x25 Storage',
		sqft: '250 Square Feet',
		looksLike: 'Spacious single-car garage',
		whatWillFit: 'Several bedroom sets, office furniture, and appliances',
	},

	'10x30': {
		title: '10x30 Storage',
		sqft: '300 Square Feet',
		looksLike: 'Two-car garage',
		whatWillFit:
			'Items from a large house, bedroom sets, major appliances, seasonal items',
	},

	'10x35': {
		title: '10x35 Storage',
		sqft: '350 Square Feet',
		looksLike: 'Extended garage',
		whatWillFit:
			'Large vehicle, moving boxes, or the majority of household contents',
	},

	'10x40': {
		title: '10x40 Storage',
		sqft: '400 Square Feet',
		looksLike: 'Multi-car garage',
		whatWillFit:
			'Average recreational vehicle, two sedans, recreational gear',
	},

	'10x50': {
		title: '10x50 Storage',
		sqft: '500 Square Feet',
		looksLike: 'Small warehouse space',
		whatWillFit:
			'Complete household contents, vehicles, boats, business inventory',
	},
};
